import React from 'react'
import { GridCell } from '@progress/kendo-react-grid'
// import DeleteIcon from '@material-ui/icons/Delete'
import CreateIcon from '@material-ui/icons/Create'
import RefreshIcon from '@material-ui/icons/Refresh'
import { Icon } from 'components/icons'
import { localized } from 'decorators'
import { Button, LinkButton, ConfirmButton } from 'components/buttons'

const BUTTON_WIDTH = 30
const actionCell = ({ actionProps: props, nameGetter, additionalButtons, isSoftDelete = false, hideDelete = false }) => {
  return localized(class ActionCell extends GridCell {
    renderEdit ({ editUrl }) {
      if (typeof editUrl === 'function') {
        return <LinkButton
          padding={0}
          minWidth='inherit'
          href={editUrl(this.props.dataItem)}
          title={this.props.localize('common.edit')}
          icon={<CreateIcon style={{ marginRight: 0 }} />}
          width={BUTTON_WIDTH}
        />
      }
      return null
    }
    
    handleDelete = (onDelete) => () => onDelete(this.props.dataItem, this.props.dataIndex - 1)
    renderDelete ({ onDelete, confirmMessage, confirmTitle }) {
      if (hideDelete != true && typeof onDelete === 'function') {
        if (typeof confirmMessage === 'function') {
          const canBeDeleted = this.props.dataItem.canBeDeleted !== false
          return <ConfirmButton
            padding={0}
            minWidth='inherit'
            className='delete-button'
            title={props.deleteButtonTooltip || this.props.localize('common.delete')}
            onConfirm={this.handleDelete(onDelete)}
            confirmMessage={confirmMessage(this.props.dataItem, nameGetter, isSoftDelete)}
            confirmTitle={this.props.localize(confirmTitle || 'common.confirm')}
            disabled={!canBeDeleted}
            color='inherit'
            variant='text'
            width={BUTTON_WIDTH}>
              <Icon name='bitbucket' />
            {/* <DeleteIcon style={{ marginRight: 0 }} /> */}
          </ConfirmButton>
        }
        return <Button
          padding={0}
          minWidth='inherit'
          title={this.props.localize('common.delete')}
          onClick={this.handleDelete(onDelete)}
          color='inherit'
          variant='text'
          className='delete-button'
          width={BUTTON_WIDTH}>
            <Icon name='bitbucket' />
          {/* <DeleteIcon /> */}
        </Button>
      }
      return null
    }
    handleRestore = (onRestore) => () => onRestore(this.props.dataItem)
    renderRestore ({ onRestore }) {
      if (typeof onRestore === 'function') {
        return <Button
          padding={0}
          minWidth='inherit'
          title={this.props.localize('common.restoreFromTrash')}
          onClick={this.handleRestore(onRestore)}
          color='inherit'
          variant='text'
          width={BUTTON_WIDTH}>
          <RefreshIcon />
        </Button>
      }
      return null
    }
    handleAdditionalButtonClick = (btn) => () => btn.onClick(this.props.dataItem) 
    renderAdditionalButtons (additionalButtons, props) {
      if (additionalButtons && additionalButtons.length > 0) {
        return additionalButtons.map((btn, idx) => {
          const disabled = (typeof btn.isDisabled === 'function' ? btn.isDisabled(this.props.dataItem) : false)
          return <Button
            key={idx}
            padding={0}
            minWidth='inherit'
            disabled={disabled}
            title={this.props.localize(btn.tooltip)}
            onClick={this.handleAdditionalButtonClick(btn)}
            color='inherit'
            variant='text'
            width={BUTTON_WIDTH}>
            <Icon name={btn.icon} />
          </Button>
        })
      }
      return null
    }
    handleCellClick = (e) => { e.stopPropagation() }
    render () {
      return (
        <td className='action-cell' onClick={this.handleCellClick}>
          {this.renderEdit(props)}
          {this.renderDelete(props)}
          {this.renderRestore(props)}
          {this.renderAdditionalButtons(additionalButtons, props)}
        </td>
      )
    }
  })
}
export {
  actionCell
}
